module.exports = __webpack_public_path__ + "static/zigzag-image1-28723c8828f1d6b433e7217772f0f0b7.png";